export default "__VITE_ASSET__bDY9mzPO__"